import { Inject, Injectable } from "@angular/core";
import { UserIntegrationResponse } from "../models/user-integration-response.model";
import { Router } from "@angular/router";
import { DwAuthenticationType, DwConfigService, DwConfigServiceToken, DwMessage, DwMessageSeverity, DwMessagingService, DwModalButtonStandardConfigs, DwModalConfig, DwModalService, DwModalSize, DwRoutingService, DwSecurityOrchestrationService, DwSecurityUserService, getParameterByName } from "@devwareapps/devware-cap";
import { IntegrationRequestToken, IntegrationTypes } from "../models/integration-request-token.model";
import { SchoolIntegrationResponse, SchoolIntegrationResponseType } from "../models/school-integration-response.model";
import { SchoolIntegrationCompletionRequest } from "../models/school-integration-completion-request.model";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { SchoolIntegrationCompletionResponse } from "../models/school-integration-completion-response.model";
import { HttpClient } from "@angular/common/http";
import { CreateSchoolModalComponent } from "../components/create-school-modal/create-school-modal.component";
import { map } from "rxjs/operators";


@Injectable({
    providedIn: 'root'
})
export class IntegrationRepositoryService {
    apiRoot: string;

    homePageIntegrationMessage: BehaviorSubject<DwMessage> = new BehaviorSubject<DwMessage>(null);

    constructor(private router: Router,
        private dwRoutingService: DwRoutingService,
        private dwMessagingService: DwMessagingService,
        private dwModalService: DwModalService,
        @Inject(DwConfigServiceToken) private dwConfigService: DwConfigService,
        private httpClient: HttpClient,
        private dwSecurityOrchestrationService: DwSecurityOrchestrationService,
        private dwSecurityUserService: DwSecurityUserService
    ) {
        this.apiRoot = this.dwConfigService.coreConfig.apiRoot;
    }


    completeSchoolIntegration(request: SchoolIntegrationCompletionRequest, schoolIntegrationResponse: SchoolIntegrationResponse) {
        const url = `${this.apiRoot}/integration/school/complete`;

        return this.httpClient.post<SchoolIntegrationCompletionResponse>(url, request);
    }

    handlecompleteSchoolIntegrationResponse(response: SchoolIntegrationCompletionResponse, schoolIntegrationResponse: SchoolIntegrationResponse) {
        if (response.Success == false) {
            schoolIntegrationResponse.ErrorMessage = response.Message;
            this.showIntegrationError(schoolIntegrationResponse);

            //this.dwMessagingService.showMessage({ messageBody: response.Message, severity: DwMessageSeverity.error });
            return;
        }

        let message = '';
        switch(schoolIntegrationResponse.ResponseType) {
            case SchoolIntegrationResponseType.CreateNewSchool:
                message = `Flight School has been created successfully and you are now the Flight School Admin.  You will be redirected to Flight Schedule Pro to complete the setup.`
                break;
            case SchoolIntegrationResponseType.ApproveIntegration:
                message = `Integration with Flight School Pro has been enabled.  You will be redirected to Flight Schedule Pro to complete the setup.`
                break;
        }

        if (message) {
            this.homePageIntegrationMessage.next({
                messageBody: message,
                severity: DwMessageSeverity.info,
            });
        }

        if (response.RefreshAuthentication) {
            this.refreshAuthentication();
        }
        
        if (response.RedirectUrl) {
            setTimeout(() => {
                console.warn("Redirecting to Flight Schedule Pro for integration completion", response.RedirectUrl);
                location.href = response.RedirectUrl;
            }, 4000);
        }
    }



    refreshAuthentication() {
       
        this.dwSecurityOrchestrationService.reAuthenticate( this.dwSecurityUserService.securityState.securityContext.SecurityToken, DwAuthenticationType.reauthenticate, false)
        .subscribe((result) => {
           // console.log("Re-authentication result", result);
        });
    }

    showIntegrationError(schoolIntegrationResponse: SchoolIntegrationResponse) {
        this.dwModalService.showDialog(
             `Integration Error`,
             `An error occured when attempting to integrate with ${schoolIntegrationResponse.IntegrationSystemName}. ${schoolIntegrationResponse.ErrorMessage}`,
            [DwModalButtonStandardConfigs.instance.okButton]
        );
    }



}
